// extracted by css-extract-rspack-plugin
module.exports =  {"root":"DetailsView__root___ilFz5","onboardingWrapper":"DetailsView__onboardingWrapper___GLW6q","txfDocumentationWrapper":"DetailsView__txfDocumentationWrapper___CyyVe"};